/**
 * Substitutes `{name}` placeholders in a route template.
 * Unknown or empty values are left in the template so the caller can fail loudly.
 */
export const applyRouteParams = (
  route: string,
  params: Record<string, string | undefined>
): string =>
  route.replace(/\{(\w+)\}/g, (placeholder, key: string) => {
    const value = params[key];
    return value ? value : placeholder;
  });
